module.exports = __webpack_public_path__ + "static/img/19.d47e279.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/19.png
// module id = 6a84
// module chunks = 0